var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.last)?_c('div',[_c('span',{class:_vm.statusClass},[_vm._v(_vm._s(_vm.template))]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.when))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }